import React from "react";

/**
 * Shared page title header: orange accent bar + title/subtitle + soft divider.
 */
export default function PageHeader({ title, subtitle, actions, style }) {
  return (
    <header className="de-page-header" style={style}>
      <div className="de-page-header-row">
        <div className="de-page-header-accent" aria-hidden="true" />
        <div className="de-page-header-text">
          <h1 className="de-page-header-title">{title}</h1>
          {subtitle ? (
            <p className="de-page-header-subtitle">{subtitle}</p>
          ) : null}
        </div>
        {actions ? (
          <div className="de-page-header-actions">{actions}</div>
        ) : null}
      </div>
      <style>{`
        .de-page-header {
          margin: 0 0 20px;
          padding: 0 0 14px;
          border-bottom: 1px solid #e6eef4;
        }
        .de-page-header-row {
          display: flex;
          align-items: flex-start;
          gap: 12px;
        }
        .de-page-header-accent {
          flex-shrink: 0;
          width: 4px;
          align-self: stretch;
          min-height: 36px;
          border-radius: 4px;
          background: #E06639;
        }
        .de-page-header-text {
          min-width: 0;
          flex: 1;
        }
        .de-page-header-title {
          margin: 0 !important;
          margin-bottom: 0 !important;
          font-size: 30px !important;
          font-weight: 700 !important;
          color: #0c3c54 !important;
          line-height: 1.2 !important;
          font-family: Poppins, sans-serif !important;
        }
        .de-page-header-subtitle {
          margin: 4px 0 0 !important;
          font-size: 15px !important;
          font-weight: 400 !important;
          color: #6a7d8c !important;
          line-height: 1.5 !important;
          font-family: Poppins, sans-serif !important;
        }
        .de-page-header-actions {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          gap: 10px;
        }
      `}</style>
    </header>
  );
}
